import { render, staticRenderFns } from "./LaboratoryConfigurationImageUploader.vue?vue&type=template&id=ae60f9ea&scoped=true&"
import script from "./LaboratoryConfigurationImageUploader.vue?vue&type=script&lang=js&"
export * from "./LaboratoryConfigurationImageUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae60f9ea",
  null
  
)

export default component.exports